import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Table } from "antd";
import routerConstant from "service/constant/routerConstant";

interface Props {
  data: any;
  count: number;
  selectPage: number;
  setSelectPage: React.Dispatch<React.SetStateAction<number>>;
  selectTable: string[];
  setSelectTable: React.Dispatch<React.SetStateAction<string[]>>;
}

const CustomTable = styled(Table)`
  .ant-table-thead > tr > th {
    color: #6b7280;
    font-size: 12px;
    font-weight: 600;
  }
  .ant-table-tbody > tr > td {
    color: #111827;
    font-size: 14px;
  }
  .routerBtn {
    font-weight: 400;
    text-decoration: underline;
    cursor: pointer;
  }
`;

export function ManagerTable({
  data,
  count,
  selectPage,
  setSelectPage,
  selectTable,
  setSelectTable,
}: Props) {
  const navigate = useNavigate();
  const handleDetailBtn = (id: string) => {
    navigate(`${routerConstant.user.manager}/${id}`);
  };

  const columns = [
    {
      title: "NO",
      dataIndex: "id",
    },
    {
      title: "구분",
      dataIndex: "isSuperAdmin",
      render: (text: boolean) => <>{text ? "최고관리자" : "관리자"}</>,
    },
    {
      title: "아이디",
      dataIndex: "adminId",
    },
    {
      title: "이름",
      dataIndex: "nickName",
    },
    {
      title: "계정 생성일",
      dataIndex: "createdAt",
      render: (text: string) => <>{moment(text).format("YYYY.MM.DD")}</>,
    },
    {
      title: "상세보기",
      dataIndex: "id",
      render: (text: number) => (
        <span className="routerBtn" onClick={() => handleDetailBtn(text + "")}>
          바로가기
        </span>
      ),
    },
  ];

  const handleSelectTableChange = (selectTable: any) => {
    setSelectTable(selectTable);
  };

  const rowSelection: any = {
    selectedRowKeys: selectTable,
    onChange: handleSelectTableChange,
  };

  return (
    <CustomTable
      rowKey="id"
      rowSelection={rowSelection}
      dataSource={data}
      columns={columns}
      pagination={{
        current: selectPage,
        pageSize: 30,
        onChange: (page) => setSelectPage(page),
        total: count,
        showSizeChanger: false,
      }}
    />
  );
}
